import { Mode } from "./models/plot";

export interface PlotModeSelectBoxItem {
  id: Mode;
  name: string;
  image: string;
}
/** プロットモード */
export const plotModes: PlotModeSelectBoxItem[] = [
  {
    id: Mode.kishoutenketsu,
    name: "起承転結",
    image: "none",
  },
  {
    id: Mode.johakyu,
    name: "序破急",
    image: "none",
  },
  {
    id: Mode.custom,
    name: "カスタム",
    image: "none",
  },
];
